import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {AppPref} from '../constants';

/**
 * @return Can contact
 */
export const canContact = () => !!getPreference(AppPref.CONTACT_EMAIL);
